import { render, staticRenderFns } from "./point-of-sale-detail.vue?vue&type=template&id=515a39b6&"
import script from "./point-of-sale-detail.vue?vue&type=script&lang=js&"
export * from "./point-of-sale-detail.vue?vue&type=script&lang=js&"
import style0 from "./point-of-sale-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports